import useMapServiceBiura from '../services/useMapServiceBiura';
import useMapServiceBiuraSzczegoly from '../services/useMapServiceBiuroSzczegoly';
import useMapServiceSzukaj from '../services/useMapServiceSzukaj';
import GoogleMapTypeEnum from '../types/googleMapTypes';
import IMapService from '../types/IMapService';

const mapServiceMap: Record<GoogleMapTypeEnum, Function> = {
  [GoogleMapTypeEnum.SZUKAJ]: useMapServiceSzukaj,
  [GoogleMapTypeEnum.BIURA]: useMapServiceBiura,
  [GoogleMapTypeEnum['BIURO-SZCZEGOLY']]: useMapServiceBiuraSzczegoly,
};

const useMapServiceFactory = (service: IMapService) => {
  const { type } = service;

  return mapServiceMap[type.value](service);
};
export default useMapServiceFactory;
